import * as gochisActions from '../actions/Gochis';

const initialState = {
  gochis: [],
  genGochis: [],
  result: [],
  offset: 0,
  limit: 10,
  totalCount: 7,
  couponCountTotal: 0,
  externalAmountTotal: 0,
  internalAmountTotal: 0,
  couponUsedCountTotal: 0,
  usedExternalAmountTotal: 0,
  usedInternalAmountTotal: 0,
  detail: {
    couponId: 1,
    groupName: 'グループ1',
    shopId: 1,
    shopName: '店舗1',
    menuName: 'オムライス',
    price: 800,
    taxType: '外税',
    gochiType: 'メニューごち',
    registerDate: '2019-01-01 12:00:00',
    registerName: 'ごち 太郎',
    useDate: '2019-01-10 12:00:00',
    userName: 'ごち 花子',
    expiration: '2019-07-01 12:00:00',
    thanksMessage: 'ごちそうさまでした！',
    situation: '女性限定',
    gochiMessage: 'ヘルシーなオムライスをご堪能ください！'
  },
  gochiTypes: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 'MENU',
      name: 'メニューごち'
    },
    {
      id: 'PRICE',
      name: 'お値段ごち'
    },
    {
      id: 'SHASHOKU',
      name: '社食チケット'
    },
    {
      id: 'LOCAL_WALLET',
      name: '地域通貨チケット'
    },
    {
      id: 'GOCHI_KID',
      name: 'こどもごちめしメニュー'
    }
  ],
  gochiUserTypes: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 'USER',
      name: 'ご指名ごち'
    },
    {
      id: 'ANYONE',
      name: 'オープンごち'
    },
    {
      id: 'NONUSER',
      name: '外部ユーザごち'
    },
    {
      id: 'YOURSELF',
      name: '自分へのごち'
    }
  ],
  gochiTypesShop: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 'MENU',
      name: 'メニューごち'
    },
    {
      id: 'PRICE',
      name: 'お値段ごち'
    },
    {
      id: 'SHASHOKU',
      name: '社食チケット'
    },
    {
      id: 'LOCAL_WALLET',
      name: '地域通貨チケット'
    },
    {
      id: 'GOCHI_KID',
      name: 'こどもごちめしメニュー'
    }
  ],
  gochiUserTypesShop: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 'USER',
      name: 'ご指名ごち'
    },
    {
      id: 'ANYONE',
      name: 'オープンごち'
    },
    {
      id: 'NONUSER',
      name: '外部ユーザごち'
    },
    {
      id: 'YOURSELF',
      name: '自分へのごち'
    }
  ],
  gochiStatuses: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: 'USED',
      name: '使用済'
    },
    {
      id: 'UNUSED',
      name: '未使用'
    },
    {
      id: 'EXPIRED',
      name: '期限切れ'
    }
  ],
  error: false,
  status: 200,
  error_message: ''
};

const gochis = (state = initialState, action) => {
  switch (action.type) {
    case gochisActions.GET_GOCHIS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochisActions.GET_GOCHIS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.GET_GEN_GOCHI_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochisActions.GET_GEN_GOCHI_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.DOWNLOAD_GOCHIS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochisActions.DOENLOAD_GOCHIS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.GET_GOCHI_DETAIL_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case gochisActions.GET_GOCHI_DETAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.SHOP_REPLY_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochisActions.SHOP_REPLY_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.GET_GOCHI_ONE_TO_N_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochisActions.GET_GOCHI_ONE_TO_N_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.CHANGE_TICKE_TO_NON_USE_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochisActions.CHANGE_TICKE_TO_NON_USE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.GET_GOCHIS_SHOP_SUCCESS:
      return Object.assign({}, state, {
        gochis: action.payload.result,
        limit: action.payload.limit,
        offset: action.payload.offset,
        totalCount: action.payload.totalCount,
        transferAmountTotal: action.payload.transferAmountTotal,
        discountAmountTotal: action.payload.discountAmountTotal,
        usedExternalAmountTotal: action.payload.usedExternalAmountTotal,
        usedInternalAmountTotal: action.payload.usedInternalAmountTotal,
        couponCountTotal: action.payload.couponCountTotal,
        externalAmountTotal: action.payload.externalAmountTotal,
        internalAmountTotal: action.payload.internalAmountTotal,
        couponUsedCountTotal: action.payload.couponUsedCountTotal
      });
    case gochisActions.GET_GOCHIS_SHOP_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.GET_BATCH_GOCHI_CHARGE_SUCCESS:
      return Object.assign({}, state, {
        listBatchGochiCharge: action.payload
      });
    case gochisActions.GET_BATCH_GOCHI_CHARGE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.GET_LIST_GOCHI_KID_USED_BY_ADMIN_SUCCESS:
      return Object.assign({}, state, {
        listGochiKidUsedByAdmin: action.payload
      });
    case gochisActions.GET_LIST_GOCHI_KID_USED_BY_ADMIN_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochisActions.GET_LIST_GOCHI_KID_USE_SUCCESS:
      return Object.assign({}, state, {
        listGochiKidUse: action.payload
      });
    case gochisActions.GET_LIST_GOCHI_KID_USE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default gochis;
